const C = "C"
const R = "R"
const U = "U"
const D = "D"

const Resource = {
	APIKeys: "APIK",
	AuditRequests: "AR",
	FlowDownAuditRequests: "FAR",
	Audits: "AU",
	FlowDownAudits: "FAU",
	AuditTemplates: "AT",
	AuditTemplateApprovals: "ATA",
	AuditFlowDown: "AFD",
	OnsiteAuditRequest: "OAR",
	OnsiteAudits: "OAU",
	Blockchain: "BC",
	Clients: "CL",
	Connections: "CO",
	Drafts: "TXDR",
	InvitationCodes: "IC",
	Presets: "TXPR",
	Transactions: "TX",
	TransactionComments: "TC",
	Users: "USR",
	Files: "FILE",
	AccessLevel: "AL", /*For backwards-compatibility*/
	Notifications: "NOTIF",
	Roles: "ROL",
	Portal: "POR",
	OtherThanOwn: "OTO",
	Billing: "BIL",
	CSR: "CSR",
	NIS: "NIS",
	ESG: "ESG",
	KPI: "KPI"
}

const Product = {
	Audit: "audit",
	AuditOnsite: "auditonsite",
	AuditFlowDown: "auditflowdown",
	Platform: "platform",
	Trace: "trace"
}

const Role = {
	Example: "example",
	ReadOnly: "read-only",
	Normal: "normal",
	Admin: "admin",
	APIKey: "apikey"
}

const Permissions = {
	[Role.Example]: {
		[Resource.APIKeys]: [C,R,U,D],
		[Resource.AuditRequests]: [C,R,U,D],
		[Resource.FlowDownAuditRequests]: [C,R,U,D],
		[Resource.Audits]: [C,R,U,D],
		[Resource.FlowDownAudits]: [C,R,U,D],
		[Resource.OnsiteAuditRequest]: [C,R,U,D],
		[Resource.OnsiteAudits]: [C,R,U,D],
		[Resource.AuditTemplates]: [C,R,U,D],
		[Resource.Blockchain]: [C,R,U,D],
		[Resource.Clients]: [C,R,U,D],
		[Resource.Connections]: [C,R,U,D],
		[Resource.Drafts]: [C,R,U,D],
		[Resource.InvitationCodes]: [C,R,U,D],
		[Resource.Presets]: [C,R,U,D],
		[Resource.Transactions]: [C,R,U,D],
		[Resource.Users]: [C,R,U,D],
		[Resource.Files]: [C,R,U,D],
		[Resource.AccessLevel]: [],
		[Resource.Notifications]: [C,R,U,D],
		[Resource.Portal]: [R]
	},
	[Role.ReadOnly]: {
		[Resource.APIKeys]: [R],
		[Resource.AuditRequests]: [R],
		[Resource.FlowDownAuditRequests]: [R],
		[Resource.Audits]: [R],
		[Resource.FlowDownAudits]: [R],
		[Resource.OnsiteAuditRequest]: [R],
		[Resource.OnsiteAudits]: [R],
		[Resource.AuditTemplates]: [R],
		[Resource.Blockchain]: [],
		[Resource.Clients]: [],
		[Resource.Connections]: [R],
		[Resource.Drafts]: [R],
		[Resource.InvitationCodes]: [R],
		[Resource.Presets]: [R],
		[Resource.Transactions]: [R],
		[Resource.Users]: [R],
		[Resource.Files]: [R],
		[Resource.AccessLevel]: [0],
		[Resource.Notifications]: [C,R,U,D],
		[Resource.Portal]: [R]
	},
	[Role.Normal]: {
		[Resource.APIKeys]: [R],
		[Resource.AuditRequests]: [C,R,D],
		[Resource.FlowDownAuditRequests]: [C,R,D],
		[Resource.Audits]: [C,R,U],
		[Resource.FlowDownAudits]: [C,R,U],
		[Resource.OnsiteAuditRequest]: [C,R,D],
		[Resource.OnsiteAudits]: [C,R,U],
		[Resource.AuditTemplates]: [C,R,U,D],
		[Resource.Blockchain]: [],
		[Resource.Clients]: [],
		[Resource.Connections]: [R],
		[Resource.Drafts]: [C,R,U,D],
		[Resource.InvitationCodes]: [R],
		[Resource.Presets]: [R],
		[Resource.Transactions]: [C,R,U],
		[Resource.Users]: [R],
		[Resource.Files]: [C,R,U,D],
		[Resource.AccessLevel]: [0,1,2,3,4,5,9],
		[Resource.Notifications]: [C,R,U,D],
		[Resource.Portal]: [R]
	},
	[Role.Admin]: {
		[Resource.APIKeys]: [C,R,D],
		[Resource.AuditRequests]: [C,R,D],
		[Resource.FlowDownAuditRequests]: [C,R,D],
		[Resource.Audits]: [C,R,U],
		[Resource.FlowDownAudits]: [C,R,U],
		[Resource.OnsiteAuditRequest]: [C,R,D],
		[Resource.OnsiteAudits]: [C,R,U],
		[Resource.AuditTemplates]: [C,R,U,D],
		[Resource.Blockchain]: [],
		[Resource.Clients]: [],
		[Resource.Connections]: [C,R,U,D],
		[Resource.Drafts]: [C,R,U,D],
		[Resource.InvitationCodes]: [C,R,U,D],
		[Resource.Presets]: [C,R,U,D],
		[Resource.Transactions]: [C,R,U],
		[Resource.Users]: [C,R,U,D],
		[Resource.Files]: [C,R,U,D],
		[Resource.AccessLevel]: [0,1,2,3,4,5,6,7,8,9,10,12],
		[Resource.Notifications]: [C,R,U,D],
		[Resource.Portal]: [R]
	},
	[Role.APIKey]: {
		[Resource.APIKeys]: [C,R,D],
		[Resource.AuditRequests]: [C,R,D],
		[Resource.FlowDownAuditRequests]: [C,R,D],
		[Resource.Audits]: [C,R,U],
		[Resource.FlowDownAudits]: [C,R,U],
		[Resource.OnsiteAuditRequest]: [C,R,D],
		[Resource.OnsiteAudits]: [C,R,U],
		[Resource.AuditTemplates]: [C,R,U,D],
		[Resource.Blockchain]: [],
		[Resource.Clients]: [],
		[Resource.Connections]: [C,U,D],
		[Resource.Drafts]: [C,R,U,D],
		[Resource.InvitationCodes]: [C,R,U,D],
		[Resource.Presets]: [C,R,U,D],
		[Resource.Transactions]: [C,R,U],
		[Resource.Users]: [C,R,U,D],
		[Resource.Files]: [C,R,U,D],
		[Resource.AccessLevel]: [0,2,3,4],
		[Resource.Notifications]: [C,R,U,D],
		[Resource.Portal]: [R],
		[Resource.CSR]: [R]
	},
}

module.exports = {Resource, Permissions, Product, Role}